import { render, staticRenderFns } from "./PassengerInfos.vue?vue&type=template&id=42f72199&scoped=true&"
import script from "./PassengerInfos.vue?vue&type=script&lang=js&"
export * from "./PassengerInfos.vue?vue&type=script&lang=js&"
import style0 from "./PassengerInfos.vue?vue&type=style&index=0&id=42f72199&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f72199",
  null
  
)

export default component.exports